module.exports = __webpack_public_path__ + "static/media/icon_tara.0d584c60.png";